import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../../3rdPartyModules/_react-aria/focus/dist/useFocusRing-BO5gj-B1.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../../3rdPartyModules/_react-aria/utils/dist/mergeProps-DMtmc2Zw.js';
import { f as focusOutline } from '../../FocusIndicator/styleMixins/focusOutline-DNwtedBp.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { c as colorMixin, L as LoadingIcon } from '../Button-BhD27vh-.js';
import { T as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const loadingStyles = /*#__PURE__*/css(["&&[aria-disabled=\"true\"]{cursor:not-allowed;", " pointer-events:none;}"], colorMixin(({
  theme
}) => theme.globals.textDisabledColor));
const StyledTextButton = /*#__PURE__*/styled('button').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    /*
     *`useFocusRing()` uses `onFocus` and `onBlur` props, so `mergeProps()` must be used to
     * make sure user supplied `onFocus` and `onBlur` are also called.
    */
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    focusVisible: isFocusVisible
  };
}).withConfig({
  componentId: "sc-storm-ui-30063520__sc-7di6d7-0"
})(["", ";font-size:", ";background:none;border:none;padding:0;color:", ";user-select:auto;", ";:hover{color:", ";text-decoration:", ";background:none;cursor:pointer;}:focus{outline:none;", "}:disabled{color:", ";cursor:not-allowed;:focus{outline:none;}:hover{text-decoration:none;}}@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms ease;}", ""], ({
  theme
}) => theme.typography.base, ({
  size,
  theme
}) => theme.link[size || 'base'], ({
  theme
}) => theme.link.color, ({
  $loading
}) => $loading && loadingStyles, ({
  theme
}) => theme.link.hoverColor, ({
  theme
}) => theme.link.hoverDecoration, ({
  focusVisible
}) => focusVisible && focusOutline, ({
  theme
}) => theme.globals.textDisabledColor, isMobile(css(["", ";font-size:", ";"], ({
  theme
}) => theme.typography.mobile.base, ({
  size,
  theme
}) => theme.mobile.link[size || 'base'])));
const TextButton = ({
  buttonRef,
  taktId,
  taktValue,
  loading,
  loadingLabel,
  children,
  onClick,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('text-button')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(StyledTextButton, _extends({
  ref: buttonRef
}, getDataTaktAttributes(), rest, {
  $loading: loading
}, loading && {
  'aria-live': 'assertive'
}, loading && {
  'aria-disabled': true
}, {
  onClick: loading ? undefined : onClick
}), loading && /*#__PURE__*/React__default.createElement(LoadingIcon, null), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, loading && loadingLabel ? loadingLabel : children)));
TextButton.propTypes = {
  type: PT.oneOf(['submit', 'reset', 'button']),
  disabled: PT.bool,
  size: PT.oneOf(['base', 'small', 'mini', 'tiny']),
  buttonRef: PT.oneOfType([PT.func, /* allow the `any` Prop Type here so prevent breaking in SSR context  */
  // eslint-disable-next-line react/forbid-prop-types
  PT.shape({
    current: PT.any
  })]),
  onClick: PT.func,
  loading: PT.bool,
  loadingLabel: PT.string
};
TextButton.defaultProps = {
  type: 'button',
  disabled: false,
  size: 'base',
  buttonRef: undefined,
  onClick: undefined,
  loading: false,
  loadingLabel: undefined
};

export { TextButton as T };
//# sourceMappingURL=TextButton-DVKktbSB.js.map
